import React from "react";
import { PAGE_SIZES } from "../../utils/pagedList";

// Ж22: выбор порции показа и кнопка массового удаления — общие для колокольчика и страницы настроек
export const PageSizeSelect = ({ value, onChange, testId }) => (
  <label className="inline-flex items-center gap-1.5 text-xs" style={{ color: "var(--rv-text-muted)" }}>
    Показывать по
    <select value={value} onChange={(e) => onChange(Number(e.target.value))} data-testid={testId}
      className="text-xs px-1.5 py-1 rounded-md" style={{ border: "1px solid var(--rv-border)", background: "white", color: "var(--rv-text-primary)" }}>
      {PAGE_SIZES.map((s) => <option key={s} value={s}>{s}</option>)}
    </select>
  </label>
);

export const ShowMoreButton = ({ shown, total, size, onClick, testId }) => {
  if (shown >= total) return null;
  return (
    <button type="button" onClick={onClick} data-testid={testId} className="w-full text-xs py-2 font-medium"
      style={{ background: "transparent", border: "none", borderTop: "1px solid var(--rv-border)", color: "var(--rv-teal)", cursor: "pointer" }}>
      Показать ещё {Math.min(size, total - shown)} (показано {shown} из {total})
    </button>
  );
};

export const BulkDeleteButton = ({ label, onClick, testId, disabled }) => (
  <button type="button" onClick={onClick} disabled={disabled} data-testid={testId} className="text-xs underline underline-offset-2"
    style={{ color: disabled ? "var(--rv-text-muted)" : "var(--rv-error)", background: "none", border: "none", cursor: disabled ? "default" : "pointer", padding: 0 }}>
    {label}
  </button>
);
